export const CHAT_USER = "CHAT_USER";
export const CHAT_REPLY = "CHAT_REPLY";
export const ACTIVE_USER = "ACTIVE_USER";
export const IMAGE_FILE = "IMAGE_FILE";
export const VIDEO_FILE = "VIDEO_FILE";
export const DOCUMENT_FILE = "DOCUMENT_FILE";
export const FULL_USER = "FULL_USER";
export const ADD_LOGGED_USER = "ADD_LOGGED_USER";
export const CREATE_GROUP = "CREATE_GROUP";
export const LOADING_CHAT = "LOADING_CHAT";
